import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { McaExternalServicesService, } from '../../../services/mca-external-services.service';
import {GlobalService,ReportsServices } from '../../../services';
import moment from 'moment';import { FileSaver, saveAs } from 'file-saver';

@Component({
    selector: 'app-external-res-req',
    templateUrl: './external-res-req.component.html',
    styleUrls: ['./external-res-req.component.scss'],
    standalone: false
})
export class ExternalResReqComponent implements OnInit {
  permissionAccess:boolean = false;
  partners:any[] = [];
  currentUser:any = null;
  constructor(
    public globalService: GlobalService,
    private mcaExternalServices: McaExternalServicesService,
    private reportsServices: ReportsServices
    ) { 
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

  ngOnInit(): void {
    this.verifyPermissionAccess();
    this.getPatners();
  }
  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
    partner: new UntypedFormControl(),
    type: new UntypedFormControl(),
  });
  types:any[] = [
    {typ: "response", viewValue: "response", status: "1"},
    {typ: "request", viewValue: "request", status: "2"},
  ];

  theresData: any;
  setType(type){
    this.typeOfData = type;
  }
  error:any = null;
  getInfo(){
    let dateStart = this.range.value.start;
    let dateEnd = this.range.value.end;
  
    let data = {
      partnerId: this.range.value.partner,
      type: this.range.value.type,
      from: moment(dateStart).format("YYYY-MM-DD"),
      to: moment(dateEnd).format("YYYY-MM-DD"),
      user_id: this.currentUser.userId
    }

    if(dateStart && dateEnd){
      if(this.range.invalid){
        this.globalService.prepareAlert({title:"Warning", message: "Faltan campos por selecionar", label: 'warn'}).subscribe(r => {})
        return
      }
      this.getDateRange(data);
    }else{
      this.globalService.prepareAlert({title:"Warning", message: "Seleccione Fechas", label: 'warn'}).subscribe(r => {})
    }
  }
  getDateRange(data:object){
    this.error = null;
    this.mcaExternalServices.getAllResponses(data).subscribe((res =>{
      if(res.data.length > 0){
        res.data.forEach(element => {
          element.date = moment(element.date).format('YYYY-MM-DD hh:mm:ss');
        });
        this.theresData = res.data;
        this.error = null;
      }else{
        this.error =  "No hay datos para mostrar";
        this.theresData = null;
      }
    }));
  }
  typeOfData:any;
  verifyPermissionAccess(){
    let modulesPermission = JSON.parse(localStorage.getItem('modulesPermission'));

    if(modulesPermission.includes('admin_external_res_req_mod')){
      this.permissionAccess = true;
    }
  }

  getPatners(){
    this.reportsServices.getMcaPartners().subscribe((r:{data:[]}) => {
      if(r['error']){
        this.error =  "Ocurrio un error: " + r['message'];
      }else{
        this.partners = r.data;
      }
    });

  }
}
